/**
 * 格式化消息时间
 * @param {number} timestamp 时间戳
 * @returns {string} 格式化后的时间
 */
export function formatMessageTime(timestamp) {
	// 添加防御性检查
	if (!timestamp) return '';

	const now = new Date();
	const date = new Date(timestamp * 1000); // 转换为毫秒
	const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
	const yesterday = new Date(today - 86400000);
	const dayBeforeYesterday = new Date(yesterday - 86400000);

	// 时间格式化（24小时制）
	const timeFormatter = new Intl.DateTimeFormat('zh-CN', {
		hour: '2-digit',
		minute: '2-digit',
		hour12: false // 使用24小时制
	});

	// 月日格式化
	const monthDayFormatter = new Intl.DateTimeFormat('zh-CN', {
		month: 'long',
		day: 'numeric'
	});

	// 年月日格式化
	const fullDateFormatter = new Intl.DateTimeFormat('zh-CN', {
		year: 'numeric',
		month: 'long',
		day: 'numeric'
	});

	if (date >= today) {
		// 今天: 只显示时间 (10:00)
		return `今天 ${timeFormatter.format(date)}`;
	} else if (date >= yesterday) {
		// 昨天: 昨天 + 时间 (昨天 14:11)
		return `昨天 ${timeFormatter.format(date)}`;
	} else if (date >= dayBeforeYesterday) {
		// 前天: 前天 + 时间 (前天 09:00)
		return `前天 ${timeFormatter.format(date)}`;
	} else if (date.getFullYear() === now.getFullYear()) {
		// 今年: 月日 + 时间 (12月12日 15:23)
		return `${monthDayFormatter.format(date)} ${timeFormatter.format(date)}`;
	} else {
		// 往年: 年月日 + 时间 (2022年12月12日 10:00)
		return `${fullDateFormatter.format(date)} ${timeFormatter.format(date)}`;
	}
}

/**
 * 判断两条消息是否超过指定分钟间隔
 * @param {number} timestamp1 时间戳1
 * @param {number} timestamp2 时间戳2
 * @param {number} minutes 分钟数
 * @returns {boolean}
 */
export function isOverTimeInterval(timestamp1, timestamp2, minutes = 15) {
	return Math.abs(timestamp1 - timestamp2) > minutes * 60;
}